import { IEquipment } from '../../../../../equipment.types.ts'
import TextStatisticCard from '@/shared/Analytics/TextStatisticCard'
import useParameterValue from '../../../../../../../services/data/hooks/useParameterValue.ts'

interface IProps {
  equipmentId: IEquipment['id']
  title: string
}

const LiftMileageStatisticsCard = (props: IProps) => {
  const value = useParameterValue(props.equipmentId, 'carMileage')

  return (
    <TextStatisticCard title={props.title} loading={value.loading} width="100%" height="84px">
      <p className="text-heading-5">{value.value ? (value.value / 1000 / 1000).toFixed(2) + ' км' : '—'}</p>
    </TextStatisticCard>
  )
}

export default LiftMileageStatisticsCard
